export const formatToCurrency = (value: number | string) => {
  const amount = parseFloat(value.toString());

  if (Number.isNaN(amount)) {
    return value;
  }

  return amount.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
  });
};
